module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointment jumbotron d-flex align-items-center"
  }, [_c('div', {
    staticClass: "appointment-info flex-grow-1"
  }, [_c('span', {
    staticClass: "d-block"
  }, [_c('fa-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "user"
    }
  }), _vm._v(" " + _vm._s(_vm.capitalize(_vm.appointment.name)) + "\n        ")], 1), _vm._v(" "), _c('span', [_c('fa-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "mobile"
    }
  }), _vm._v(" " + _vm._s(_vm.appointment.telephone) + "\n        ")], 1)]), _vm._v(" "), (_vm.appointment.person_id) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-1",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "title": "Bekijk persoon",
      "to": {
        name: 'personEdit',
        params: {
          personId: _vm.appointment.person_id
        }
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "user"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.appointment.note) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-1",
    attrs: {
      "type": "button",
      "variant": "outline-success",
      "title": _vm.appointment.note
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "question-circle"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "danger",
      "title": "Afspraak annuleren"
    },
    on: {
      "click": _vm.doDelete
    }
  }, [(!_vm.isDeleting) ? _c('fa-icon', {
    attrs: {
      "icon": "trash"
    }
  }) : _c('loader-spinner', {
    attrs: {
      "iscolor": "#F0F0F0",
      "show-spinner": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea3b697a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Planning/Appointment.vue
// module id = 1346
// module chunks = 1